"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CharacterBeeOutlineIcon = void 0;
var React = __importStar(require("react"));
function CharacterBeeOutlineIcon(props) {
  var _a, _b, _c, _d;
  return React.createElement("svg", __assign({
    width: (_a = props.width) !== null && _a !== void 0 ? _a : 24,
    height: (_b = props.height) !== null && _b !== void 0 ? _b : 24,
    xmlns: "http://www.w3.org/2000/svg",
    fill: (_c = props.fill) !== null && _c !== void 0 ? _c : "#191C22",
    viewBox: (_d = props.viewBox) !== null && _d !== void 0 ? _d : "0 0 24 24"
  }, props), React.createElement("g", {
    clipPath: "url(#a)"
  }, React.createElement("path", {
    d: "M19.001 9h-2.85c.218-.456.35-.96.35-1.5 0-1.394-.82-2.587-2-3.15V4a1.002 1.002 0 0 1 1-1h1V1h-1a3 3 0 0 0-3 3h-1a3 3 0 0 0-3-3h-1v2h1c.552.001.999.448 1 1v.35c-1.18.563-2 1.756-2 3.15 0 .54.132 1.044.35 1.5H5a4.5 4.5 0 1 0 1.625 8.695c.126 1.768 1.068 3.47 2.74 4.4a5.472 5.472 0 0 0 7.44-2.134c.396-.712.576-1.489.61-2.253a4.482 4.482 0 0 0 1.585.292 4.5 4.5 0 0 0 0-9ZM8.617 17.008c.038-.499.172-.993.417-1.449l.137-.208h5.66l.169.256c.206.418.35.905.404 1.4H8.617Zm1.873-3.657L12 11.058l1.511 2.293H10.49ZM11 6h2a1.502 1.502 0 0 1 1.5 1.5 1.502 1.502 0 0 1-1.5 1.5h-2a1.502 1.502 0 0 1-1.5-1.5 1.502 1.502 0 0 1 1.5-1.5Zm-8.5 7.5a2.503 2.503 0 0 1 2.5-2.5h4.643l-2.338 3.547c-.002.001-.002.003-.003.005l-.214.323A2.497 2.497 0 0 1 5.001 16a2.504 2.504 0 0 1-2.5-2.5Zm9.516 7.283c-.57 0-1.144-.14-1.68-.437a3.28 3.28 0 0 1-1.307-1.338h6.018a3.47 3.47 0 0 1-3.031 1.775ZM19 16a2.497 2.497 0 0 1-2.088-1.125l-.166-.25c-.004-.008-.006-.017-.01-.024l-.004.002L14.358 11H19a2.503 2.503 0 0 1 2.5 2.5 2.504 2.504 0 0 1-2.5 2.5Z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "a"
  }, React.createElement("path", {
    transform: "translate(.001)",
    d: "M0 0h24v24H0z"
  }))));
}
exports.CharacterBeeOutlineIcon = CharacterBeeOutlineIcon;